import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
	providedIn: "root",
})
export class ComparisonGuard  {
	constructor(private router: Router, private authService: AuthService) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean> | boolean {
		let status = this.authService.isLoggedIn();

		if (status) {
			if (state.url.startsWith("/comparison")) {
				const idQueryParam = route.queryParams["id"];
				const linkId = route.paramMap.get("id");

				this.router.navigate(["/u/comparison", linkId], {
                    skipLocationChange: true,
					queryParams: { id: idQueryParam },
				});

				// Return false to cancel the current navigation
				return false;
			}

			// If not trying to access "/quotation", allow the navigation to proceed
			return true;
		}

		// If not logged in, allow the navigation to proceed
		return true;
	}
}
